/**
 *
 * @ScriptName  : responsive-css.js
 * @Version     : 1.0.0
 * @Author      : masahiro.imanaka
 * @Description :
 *
 * ＜使い方＞
 *
 *
 */


(function( ){


	ResponsiveCSS = function( selecter , initObj , autoFirstUpdate )
	{
		var _this = this , i ;

		var _style = document.createElement( "style" ) ;
		document.body.appendChild( _style ) ;

		this.x = 0 ;
		this.y = 0 ;
		this.scaleX = 1 ;
		this.scaleY = 1 ;
		this.rotation = 0 ;
		this.sp = {
			x: 0,
			y: 0,
			scaleX: 1,
			scaleY: 1,
			rotation: 0
		} ;
		this.pc = {
			x: 0,
			y: 0,
			scaleX: 1,
			scaleY: 1,
			rotation: 0
		} ;

		this.update = function( )
		{
			var transform = "" ;
			if( _this.x != 0 || _this.y != 0 || _this.scaleX != 1 || _this.scaleY != 1 || _this.rotation != 0 )
			{
				transform = _this.scaleX + ResponsiveCSS.COMMA +
							ResponsiveCSS.MATRIX_B_C +
							_this.scaleY + ResponsiveCSS.COMMA +
							_this.x + ResponsiveCSS.COMMA +
							_this.y ;
				var rotate = "" ;
				if( _this.rotation )
				{
					rotate = ResponsiveCSS.ROTATE_OPEN + _this.rotation + ResponsiveCSS.ROTATE_CLOSE ;
				}
				transform = ResponsiveCSS.MATRIX_OPEN + transform + ResponsiveCSS.MATRIX_CLOSE + rotate + ResponsiveCSS.SEMICOLON +
							ResponsiveCSS.WEBKIT_MATRIX_OPEN + transform + ResponsiveCSS.MATRIX_CLOSE + rotate + ResponsiveCSS.SEMICOLON ;
			}

			var transform_sp = "" ;
			if( _this.sp.x != 0 || _this.sp.y != 0 || _this.sp.scaleX != 1 || _this.sp.scaleY != 1 || _this.sp.rotation != 0 )
			{
				transform_sp = 	_this.sp.scaleX + ResponsiveCSS.COMMA +
								ResponsiveCSS.MATRIX_B_C +
								_this.sp.scaleY + ResponsiveCSS.COMMA +
								_this.sp.x + ResponsiveCSS.COMMA +
								_this.sp.y ;
				var rotate_sp = "" ;
				if( _this.sp.rotation )
				{
					rotate_sp = ResponsiveCSS.ROTATE_OPEN + _this.sp.rotation + ResponsiveCSS.ROTATE_CLOSE ;
				}
				transform_sp = 	ResponsiveCSS.MATRIX_OPEN + transform_sp + ResponsiveCSS.MATRIX_CLOSE + rotate_sp + ResponsiveCSS.SEMICOLON +
								ResponsiveCSS.WEBKIT_MATRIX_OPEN + transform_sp + ResponsiveCSS.MATRIX_CLOSE + rotate_sp + ResponsiveCSS.SEMICOLON ;
			}

			var transform_pc = "" ;
			if( _this.pc.x != 0 || _this.pc.y != 0 || _this.pc.scaleX != 1 || _this.pc.scaleY != 1 || _this.pc.rotation != 0 )
			{
				transform_pc = 	_this.pc.scaleX + ResponsiveCSS.COMMA +
								ResponsiveCSS.MATRIX_B_C +
								_this.pc.scaleY + ResponsiveCSS.COMMA +
								_this.pc.x + ResponsiveCSS.COMMA +
								_this.pc.y ;
				var rotate_pc = "" ;
				if( _this.pc.rotation )
				{
					rotate_pc = ResponsiveCSS.ROTATE_OPEN + _this.pc.rotation + ResponsiveCSS.ROTATE_CLOSE ;
				}
				transform_pc = 	ResponsiveCSS.MATRIX_OPEN + transform_pc + ResponsiveCSS.MATRIX_CLOSE + rotate_pc + ResponsiveCSS.SEMICOLON +
								ResponsiveCSS.WEBKIT_MATRIX_OPEN + transform_pc + ResponsiveCSS.MATRIX_CLOSE + rotate_pc + ResponsiveCSS.SEMICOLON ;
			}

			//   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -

			var extra = "" ;
			for( i in _this )
			{
				if( !ResponsiveCSS.REG_FUNC_PC_SP_XY_SCALE_ROTATION.test(i) )
				{
					extra = extra + i + ResponsiveCSS.COLON + _this[i] + ResponsiveCSS.SEMICOLON ;
				}
			}

			var extraSP = "" ;
			for( i in _this.sp )
			{
				if( !ResponsiveCSS.REG_XY_SCALE_ROTATION.test(i) )
				{
					extraSP = extraSP + i + ResponsiveCSS.COLON + _this.sp[i] + ResponsiveCSS.SEMICOLON ;
				}
			}

			var extraPC = "" ;
			for( i in _this.pc )
			{
				if( !ResponsiveCSS.REG_XY_SCALE_ROTATION.test(i) )
				{
					extraPC = extraPC + i + ResponsiveCSS.COLON + _this.pc[i] + ResponsiveCSS.SEMICOLON ;
				}
			}

			//   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -

			_style.innerHTML =	selecter + ResponsiveCSS.STYLE_OPEN +
								transform + extra +
								ResponsiveCSS.STYLE_CLOSE +

								ResponsiveCSS.MEDIA_SP + selecter + ResponsiveCSS.STYLE_OPEN +
								transform_sp + extraSP +
								ResponsiveCSS.STYLE_CLOSE + ResponsiveCSS.MEDIA_CLOSE +

								ResponsiveCSS.MEDIA_PC + selecter + ResponsiveCSS.STYLE_OPEN +
								transform_pc + extraPC +
								ResponsiveCSS.STYLE_CLOSE + ResponsiveCSS.MEDIA_CLOSE ;
		}

		// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

		this.remove = function( )
		{
			_style.innerHTML = "" ;
			_style.parentNode.removeChild( _style ) ;
		}

		// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

		if( initObj )
		{
			ResponsiveCSS.setParams( this , initObj , true ) ;
		}

		autoFirstUpdate = autoFirstUpdate == undefined ? true : autoFirstUpdate ;
		if( autoFirstUpdate ){
			this.update( ) ;
		}

		// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	}
	ResponsiveCSS.MEDIA_SP = "@media screen and (max-width:736px){" ;
	ResponsiveCSS.MEDIA_PC = "@media screen and (min-width:737px){" ;
	ResponsiveCSS.MEDIA_CLOSE = "}" ;
	ResponsiveCSS.STYLE_OPEN = "{" ;
	ResponsiveCSS.STYLE_CLOSE = "} " ;
	ResponsiveCSS.MATRIX_OPEN = "transform:matrix(" ;
	ResponsiveCSS.WEBKIT_MATRIX_OPEN = "-webkit-transform:matrix(" ;
	ResponsiveCSS.MATRIX_CLOSE = ")" ;
	ResponsiveCSS.MATRIX_B_C = "0,0," ;
	ResponsiveCSS.ROTATE_OPEN = " rotate(" ;
	ResponsiveCSS.ROTATE_CLOSE = "deg)" ;
	ResponsiveCSS.COMMA = "," ;
	ResponsiveCSS.COLON = ":" ;
	ResponsiveCSS.SEMICOLON = ";" ;
	ResponsiveCSS.REG_XY_SCALE_ROTATION = /^x$|^y$|^scaleX$|^scaleY$|^rotation$/ ;
	ResponsiveCSS.REG_FUNC_PC_SP_XY_SCALE_ROTATION = /^extend$|^data$|^extra$|^update$|^remove$|^pc$|^sp$|^x$|^y$|^scaleX$|^scaleY$|^rotation$/ ;

	ResponsiveCSS.setParams = function( _target , _initObj , _execution )
	{
		if( _target instanceof Array )
		{
			for( var _i in _target )		ResponsiveCSS.setParams( _target[_i] , _initObj , _execution ) ;
			return ;
		}

		//    -    -    -    -    -    -    -    -    -

		if( _target && _initObj )
		{
			for( var _paramStr in _initObj )
			{
				if( _execution || _target[_paramStr] != undefined )
				{
					if( _initObj[_paramStr] instanceof Function )
					{
						_target[_paramStr] = _initObj[_paramStr] ;
					}
					else if( _initObj[_paramStr] instanceof Object )
					{
						ResponsiveCSS.setParams( _target[_paramStr] , _initObj[_paramStr] , _execution ) ;
					}
					else
					{
						_target[_paramStr] = _initObj[_paramStr] ;
					}
				}
			}
		}
	}


} )( ) ;
